import { type KeyboardEvent, useContext, useState } from "react";
import { TextField, TriggerButton, TriggerButtonSize } from "widgets";

import { ColumnTemplatesContext } from "./column-templates/context.ts";

export const ColumnFilter = () => {
  const { gridApi } = useContext(ColumnTemplatesContext);
  const [filterText, setFilterText] = useState("");

  const onFilterTextChange = (value: string) => {
    setFilterText(value);

    if (gridApi.current) {
      gridApi.current.setGridOption("quickFilterText", value.trim() || undefined);
    }
  };

  const clearFilter = async () => {
    setFilterText("");
    if (gridApi.current) {
      const filterInstance = await gridApi.current.getColumnFilterInstance("ag-Grid-AutoColumn");
      if (filterInstance) {
        gridApi.current.setGridOption("quickFilterText", undefined);
      }
    }
  };

  // Prevents closing the popover when input field has the focus
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape" && filterText) {
      e.stopPropagation();
      clearFilter();
    }
  };

  return (
    <TextField
      label={""}
      value={filterText}
      placeholder={"Search..."}
      onChange={onFilterTextChange}
      onKeyDown={handleKeyDown}
      action={
        filterText ? (
          <TriggerButton icon="close" label="Clear" onPress={clearFilter} size={TriggerButtonSize.Small} />
        ) : undefined
      }
    />
  );
};
